<style scoped lang="less">
  .kb-fab {
    position: fixed;
    z-index: 2600;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.35);
    background: radial-gradient(circle at 30% 30%, #1e3a8a, #0b1220 70%);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18), 0 10px 28px rgba(15, 23, 42, 0.35);
    color: #e2e8f0;
    font-size: 13px;
    font-weight: 600;
    cursor: grab;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .kb-fab:active { cursor: grabbing; }

  .kb-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2600;
    background: rgba(2, 6, 23, 0.55);
  }

  .kb-panel {
    position: fixed;
    z-index: 2601;
    min-width: 360px;
    min-height: 320px;
    border-radius: 12px;
    background: #0f172a;
    color: #e2e8f0;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.35);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  .kb-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.25);
    background: linear-gradient(90deg, rgba(37, 99, 235, 0.35), transparent 55%);
    cursor: move;
    user-select: none;
    flex-shrink: 0;
  }
  .kb-head h4 {
    margin: 0;
    font-size: 15px;
  }
  .kb-head .sub {
    font-size: 12px;
    color: #94a3b8;
  }
  .kb-actions a {
    color: #93c5fd;
    margin-left: 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .kb-actions a:hover {
    color: #bfdbfe;
  }

  .kb-msgs {
    flex: 1;
    overflow: auto;
    padding: 12px 14px;
    min-height: 0;
  }
  .kb-empty {
    color: #94a3b8;
    font-size: 13px;
    line-height: 1.6;
    padding: 24px 8px;
  }
  .kb-bubble {
    max-width: 88%;
    margin-bottom: 10px;
    padding: 8px 10px;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1.55;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .kb-bubble.user {
    margin-left: auto;
    background: #1d4ed8;
  }
  .kb-bubble.bot {
    background: #1e293b;
    border: 1px solid rgba(148, 163, 184, 0.2);
  }
  .kb-sources {
    margin-top: 6px;
    font-size: 12px;
    color: #93c5fd;
  }
  .kb-foot {
    padding: 10px 12px 12px;
    border-top: 1px solid rgba(148, 163, 184, 0.25);
    background: #0b1220;
    flex-shrink: 0;
  }
  .kb-foot textarea {
    width: 100%;
    min-height: 64px;
    resize: none;
    border-radius: 8px;
    border: 1px solid rgba(148, 163, 184, 0.35);
    background: #111827;
    color: #e2e8f0;
    padding: 8px;
    margin-bottom: 8px;
    box-sizing: border-box;
  }
  .kb-foot .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .kb-resize {
    position: absolute;
    z-index: 2;
    background: transparent;
  }
  .kb-resize.n { top: -3px; left: 8px; right: 8px; height: 6px; cursor: ns-resize; }
  .kb-resize.s { bottom: -3px; left: 8px; right: 8px; height: 6px; cursor: ns-resize; }
  .kb-resize.e { right: -3px; top: 8px; bottom: 8px; width: 6px; cursor: ew-resize; }
  .kb-resize.w { left: -3px; top: 8px; bottom: 8px; width: 6px; cursor: ew-resize; }
  .kb-resize.ne { top: -4px; right: -4px; width: 12px; height: 12px; cursor: nesw-resize; }
  .kb-resize.nw { top: -4px; left: -4px; width: 12px; height: 12px; cursor: nwse-resize; }
  .kb-resize.se { bottom: -4px; right: -4px; width: 12px; height: 12px; cursor: nwse-resize; }
  .kb-resize.sw { bottom: -4px; left: -4px; width: 12px; height: 12px; cursor: nesw-resize; }
</style>
<template>
  <div v-if="visible">
    <div
      v-show="!open"
      class="kb-fab"
      :style="fabStyle"
      @mousedown="onFabDown"
      @click="onFabClick"
    >知识</div>

    <div
      v-if="open && maximized"
      class="kb-mask"
      @mousedown.self="onMaskDown"
    ></div>

    <div
      v-if="open"
      class="kb-panel"
      :style="panelStyle"
      @mousedown.stop
    >
      <div class="kb-head" @mousedown="onWinDragDown">
        <div>
          <h4>知识助手</h4>
        </div>
        <div class="kb-actions" @mousedown.stop>
          <a href="javascript:;" @click.prevent="clearChat">清空</a>
          <a href="javascript:;" @click.prevent="toggleMaximize">{{ maximized ? '缩小' : '放大' }}</a>
          <a href="javascript:;" @click.prevent="closePanel">关闭</a>
        </div>
      </div>
      <div class="kb-msgs" ref="msgs">
        <div v-if="!messages.length" class="kb-empty">{{ emptyText }}</div>
        <div
          v-for="(m, idx) in messages"
          :key="idx"
          class="kb-bubble"
          :class="m.role"
        >
          <div>{{ m.text }}</div>
          <div v-if="m.sources && m.sources.length" class="kb-sources">
            来源：
            <span v-for="(s, i) in m.sources" :key="i">{{ s.kbName || s.title }}{{ i < m.sources.length - 1 ? '、' : '' }}</span>
          </div>
        </div>
        <div v-if="sending" class="kb-empty">{{ hasBind ? '正在检索知识库…' : '思考中…' }}</div>
      </div>
      <div class="kb-foot">
        <textarea v-model="draft" maxlength="1000" placeholder="输入问题，Enter 发送（Shift+Enter 换行）" @keydown="onKey"></textarea>
        <div class="row">
          <span style="font-size: 12px; color: #64748b;">{{ providerHint }}</span>
          <Button type="primary" size="small" :loading="sending" @click="send">发送</Button>
        </div>
      </div>

      <div
        v-for="dir in resizeDirs"
        :key="dir"
        class="kb-resize"
        :class="dir"
        @mousedown.stop.prevent="onResizeDown(dir, $event)"
      ></div>
    </div>
  </div>
</template>
<script>
  import { KB_URI, KB_FAB_POS_KEY, KB_WIN_GEOM_KEY } from '@/tools/kbApi'

  var MIN_W = 360
  var MIN_H = 320

  export default {
    name: 'KbAssistant',
    data () {
      return {
        visible: false,
        open: false,
        maximized: false,
        fab: { left: null, top: null },
        win: { left: 0, top: 0, width: 720, height: 560 },
        preMaxWin: null,
        fabDragging: false,
        fabMoved: false,
        fabOff: { x: 0, y: 0 },
        winDragging: false,
        winMoved: false,
        winOff: { x: 0, y: 0 },
        resizing: false,
        resizeDir: '',
        resizeStart: null,
        resizeDirs: ['n', 's', 'e', 'w', 'ne', 'nw', 'se', 'sw'],
        bases: [],
        hasBind: false,
        providerConfigured: true,
        messages: [],
        draft: '',
        sending: false,
        maskArmed: false
      }
    },
    computed: {
      fabStyle () {
        let left = this.fab.left
        let top = this.fab.top
        if (left == null || top == null) {
          return { right: '24px', bottom: '24px', left: 'auto', top: 'auto' }
        }
        return { left: left + 'px', top: top + 'px', right: 'auto', bottom: 'auto' }
      },
      panelStyle () {
        return {
          left: this.win.left + 'px',
          top: this.win.top + 'px',
          width: this.win.width + 'px',
          height: this.win.height + 'px'
        }
      },
      emptyText () {
        return '先问一句。有关联知识库时会检索后回答；未关联则为普通问答。'
      },
      providerHint () {
        return this.providerConfigured ? '' : '模拟模式（未配置 IMA 密钥）'
      }
    },
    created () {
      this.restoreFab()
      this.restoreWin()
      this.bootstrap()
      window.addEventListener('resize', this.onViewportResize)
    },
    beforeDestroy () {
      this.unbindPointer()
      window.removeEventListener('resize', this.onViewportResize)
    },
    methods: {
      defaultWinGeom () {
        let vw = window.innerWidth || 1280
        let vh = window.innerHeight || 800
        let width = Math.round(vw * 0.72)
        let height = Math.round(vh * 0.78)
        width = Math.max(MIN_W, Math.min(width, vw - 24))
        height = Math.max(MIN_H, Math.min(height, vh - 24))
        let left = Math.round((vw - width) / 2)
        let top = Math.round((vh - height) / 2)
        return { left: left, top: top, width: width, height: height }
      },
      clampWin (g) {
        let vw = window.innerWidth || 1280
        let vh = window.innerHeight || 800
        let width = Math.max(MIN_W, Math.min(g.width, vw - 16))
        let height = Math.max(MIN_H, Math.min(g.height, vh - 16))
        let left = Math.max(0, Math.min(g.left, vw - width))
        let top = Math.max(0, Math.min(g.top, vh - height))
        return { left: left, top: top, width: width, height: height }
      },
      restoreFab () {
        try {
          let raw = localStorage.getItem(KB_FAB_POS_KEY)
          if (!raw) return
          let pos = JSON.parse(raw)
          if (pos && typeof pos.left === 'number' && typeof pos.top === 'number') {
            this.fab = { left: pos.left, top: pos.top }
          }
        } catch (e) {}
      },
      saveFab () {
        try {
          localStorage.setItem(KB_FAB_POS_KEY, JSON.stringify(this.fab))
        } catch (e) {}
      },
      restoreWin () {
        try {
          let raw = localStorage.getItem(KB_WIN_GEOM_KEY)
          if (!raw) {
            this.win = this.defaultWinGeom()
            return
          }
          let g = JSON.parse(raw)
          if (g && typeof g.left === 'number' && typeof g.top === 'number' &&
              typeof g.width === 'number' && typeof g.height === 'number') {
            this.win = this.clampWin(g)
          } else {
            this.win = this.defaultWinGeom()
          }
        } catch (e) {
          this.win = this.defaultWinGeom()
        }
      },
      saveWin () {
        if (this.maximized) return
        try {
          localStorage.setItem(KB_WIN_GEOM_KEY, JSON.stringify(this.win))
        } catch (e) {}
      },
      onViewportResize () {
        if (!this.open) return
        if (this.maximized) {
          this.applyMaximizeGeom()
        } else {
          this.win = this.clampWin(this.win)
        }
      },
      bootstrap () {
        this.$http.post(KB_URI.askAllowed, {}).then(res => {
          if (res && res.status === 'ok' && res.data && res.data.allowed === true) {
            this.visible = true
            this.hasBind = !!res.data.hasBind
            this.providerConfigured = res.data.providerConfigured !== false
            this.bases = res.data.bases || []
          } else {
            this.visible = false
          }
        }).catch(() => { this.visible = false })
      },
      onFabDown (e) {
        this.fabDragging = true
        this.fabMoved = false
        let rect = e.currentTarget.getBoundingClientRect()
        this.fabOff = { x: e.clientX - rect.left, y: e.clientY - rect.top }
        if (this.fab.left == null) {
          this.fab = { left: rect.left, top: rect.top }
        }
        document.addEventListener('mousemove', this.onFabMove)
        document.addEventListener('mouseup', this.onFabUp)
        e.preventDefault()
      },
      onFabMove (e) {
        if (!this.fabDragging) return
        this.fabMoved = true
        let left = e.clientX - this.fabOff.x
        let top = e.clientY - this.fabOff.y
        left = Math.max(8, Math.min(window.innerWidth - 60, left))
        top = Math.max(8, Math.min(window.innerHeight - 60, top))
        this.fab = { left: left, top: top }
      },
      onFabUp () {
        if (this.fabDragging && this.fabMoved) {
          this.saveFab()
        }
        this.fabDragging = false
        document.removeEventListener('mousemove', this.onFabMove)
        document.removeEventListener('mouseup', this.onFabUp)
        setTimeout(() => { this.fabMoved = false }, 0)
      },
      onFabClick () {
        if (this.fabMoved) return
        this.openPanel()
      },
      openPanel () {
        // 首次（无记忆尺寸）用视口比例居中大窗；有记忆则恢复
        let raw = null
        try { raw = localStorage.getItem(KB_WIN_GEOM_KEY) } catch (e) {}
        if (!raw) {
          this.win = this.defaultWinGeom()
        } else {
          this.win = this.clampWin(this.win)
        }
        this.maximized = false
        this.preMaxWin = null
        this.open = true
        this.maskArmed = false
      },
      closePanel () {
        this.open = false
        this.maximized = false
        this.maskArmed = false
        this.unbindPointer()
      },
      applyMaximizeGeom () {
        let vw = window.innerWidth || 1280
        let vh = window.innerHeight || 800
        let width = Math.round(vw * 0.92)
        let height = Math.round(vh * 0.9)
        let left = Math.round((vw - width) / 2)
        let top = Math.round((vh - height) / 2)
        this.win = this.clampWin({ left: left, top: top, width: width, height: height })
      },
      toggleMaximize () {
        if (this.maximized) {
          this.maximized = false
          this.maskArmed = false
          if (this.preMaxWin) {
            this.win = this.clampWin(this.preMaxWin)
          } else {
            this.win = this.defaultWinGeom()
          }
          this.preMaxWin = null
          this.saveWin()
          return
        }
        this.preMaxWin = {
          left: this.win.left,
          top: this.win.top,
          width: this.win.width,
          height: this.win.height
        }
        this.maximized = true
        this.applyMaximizeGeom()
        // 避免「放大」同一次点击落到新蒙层上立刻缩小
        this.maskArmed = false
        setTimeout(() => { this.maskArmed = true }, 280)
      },
      onMaskDown () {
        if (!this.maskArmed) return
        this.toggleMaximize()
      },
      onWinDragDown (e) {
        if (e.button != null && e.button !== 0) return
        if (this.maximized) return
        this.winDragging = true
        this.winMoved = false
        this.winOff = {
          x: e.clientX - this.win.left,
          y: e.clientY - this.win.top
        }
        document.addEventListener('mousemove', this.onWinDragMove)
        document.addEventListener('mouseup', this.onWinDragUp)
        e.preventDefault()
      },
      onWinDragMove (e) {
        if (!this.winDragging) return
        this.winMoved = true
        let left = e.clientX - this.winOff.x
        let top = e.clientY - this.winOff.y
        this.win = this.clampWin({
          left: left,
          top: top,
          width: this.win.width,
          height: this.win.height
        })
      },
      onWinDragUp () {
        if (this.winDragging && this.winMoved) {
          this.saveWin()
        }
        this.winDragging = false
        document.removeEventListener('mousemove', this.onWinDragMove)
        document.removeEventListener('mouseup', this.onWinDragUp)
      },
      onResizeDown (dir, e) {
        if (this.maximized) return
        this.resizing = true
        this.resizeDir = dir
        this.resizeStart = {
          x: e.clientX,
          y: e.clientY,
          left: this.win.left,
          top: this.win.top,
          width: this.win.width,
          height: this.win.height
        }
        document.addEventListener('mousemove', this.onResizeMove)
        document.addEventListener('mouseup', this.onResizeUp)
      },
      onResizeMove (e) {
        if (!this.resizing || !this.resizeStart) return
        let dx = e.clientX - this.resizeStart.x
        let dy = e.clientY - this.resizeStart.y
        let left = this.resizeStart.left
        let top = this.resizeStart.top
        let width = this.resizeStart.width
        let height = this.resizeStart.height
        let dir = this.resizeDir
        if (dir.indexOf('e') >= 0) {
          width = this.resizeStart.width + dx
        }
        if (dir.indexOf('s') >= 0) {
          height = this.resizeStart.height + dy
        }
        if (dir.indexOf('w') >= 0) {
          width = this.resizeStart.width - dx
          left = this.resizeStart.left + dx
        }
        if (dir.indexOf('n') >= 0) {
          height = this.resizeStart.height - dy
          top = this.resizeStart.top + dy
        }
        if (width < MIN_W) {
          if (dir.indexOf('w') >= 0) {
            left = this.resizeStart.left + (this.resizeStart.width - MIN_W)
          }
          width = MIN_W
        }
        if (height < MIN_H) {
          if (dir.indexOf('n') >= 0) {
            top = this.resizeStart.top + (this.resizeStart.height - MIN_H)
          }
          height = MIN_H
        }
        this.win = this.clampWin({ left: left, top: top, width: width, height: height })
      },
      onResizeUp () {
        if (this.resizing) {
          this.saveWin()
        }
        this.resizing = false
        this.resizeDir = ''
        this.resizeStart = null
        document.removeEventListener('mousemove', this.onResizeMove)
        document.removeEventListener('mouseup', this.onResizeUp)
      },
      unbindPointer () {
        document.removeEventListener('mousemove', this.onFabMove)
        document.removeEventListener('mouseup', this.onFabUp)
        document.removeEventListener('mousemove', this.onWinDragMove)
        document.removeEventListener('mouseup', this.onWinDragUp)
        document.removeEventListener('mousemove', this.onResizeMove)
        document.removeEventListener('mouseup', this.onResizeUp)
      },
      clearChat () {
        this.messages = []
      },
      onKey (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          this.send()
        }
      },
      send () {
        let q = (this.draft || '').trim()
        if (!q) {
          this.$Message.warning('请输入问题')
          return
        }
        if (this.sending) return
        this.messages.push({ role: 'user', text: q })
        this.draft = ''
        this.sending = true
        let payload = { question: q }
        this.$http.post(KB_URI.ask, payload).then(res => {
          this.sending = false
          if (res && res.status === 'ok' && res.data) {
            this.messages.push({
              role: 'bot',
              text: res.data.answer || '',
              sources: res.data.sources || []
            })
          } else {
            this.messages.push({ role: 'bot', text: '请求失败，请稍后重试。' })
          }
          this.$nextTick(() => {
            let el = this.$refs.msgs
            if (el) el.scrollTop = el.scrollHeight
          })
        }).catch(() => {
          this.sending = false
          this.messages.push({ role: 'bot', text: '请求失败，请稍后重试。' })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// KbAssistant.vue?01019059